import styled from 'styled-components';

export const BodyStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;

  .share-confirmation-alert {
    width: 100%;
    padding: 8px !important;
  }
`;

export const DashboardTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const CountRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
`;

export const CountItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Separator = styled.span`
  color: #e0e0e0;
  font-size: 14px;
`;

export const Table = styled.div`
  width: 100%;
  border: 1px solid ${(props) => props.theme.colors.ghostWhite};
  border-radius: 8px;
  overflow: hidden;
`;

export const TableHead = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 0 0 16px 0;
  background: ${(props) => props.theme.colors.ghostWhite};
`;

export const ThName = styled.div`
  flex: 1;
  min-width: 0;
`;

export const ThCanDo = styled.div`
  flex: 0 0 180px;
  max-width: 100%;
`;

export const ThAccess = styled.div`
  flex: 0 0 268px;
  max-width: 100%;
  display: flex;
  justify-content: flex-end;

  & > * {
    text-align: right;
  }
`;

export const TableBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const Tr = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 0;
  border-top: 1px solid ${(props) => props.theme.colors.ghostWhite};
`;

export const TdName = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const NameBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export const TdCanDo = styled.div`
  flex: 0 0 180px;
  max-width: 100%;
`;

export const TagsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;

export const TdAccess = styled.div`
  flex: 0 0 268px;
  max-width: 100%;
  display: flex;
  justify-content: flex-end;

  & > * {
    text-align: right;
  }
`;

export const FooterRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 8px;
`;
